module.exports = __webpack_public_path__ + "static/img/sx.6507ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit/sx.png
// module id = btIp
// module chunks = 1